import { PROGRAMS } from 'shared/lib/programs';
import { Program } from 'shared/api/retail';

export const AMPLIFY_ORANGE = '#f37321';

export const PROGRAMS_COLORS: Record<PROGRAMS, string> = {
  [PROGRAMS.CKLA]: '#f8cd53',
  [PROGRAMS.CAMINOS]: '#dc5c55',
  [PROGRAMS.ELAR]: AMPLIFY_ORANGE,
  [PROGRAMS.ELA]: '#6fafff',
  [PROGRAMS.ELD]: '#5c78ed',
  [PROGRAMS.MATH]: '#65dbbb',
  [PROGRAMS.SCIENCE]: '#9d71de',
  [PROGRAMS.BOOST]: '#3ab6be',
  [PROGRAMS.VOCAB_APP]: '#ef9781',
  [PROGRAMS.MATH_SUPPLEMENTAL]: '#c5e071',
  [PROGRAMS.MCLASS]: '#cf5ea2',
};

export const PROGRAMS_OUTLINED_COLORS: Record<PROGRAMS, string> = {
  [PROGRAMS.CKLA]: '#B38B1A',
  [PROGRAMS.CAMINOS]: '#DC5C55',
  [PROGRAMS.ELAR]: AMPLIFY_ORANGE,
  [PROGRAMS.ELA]: '#6495D1',
  [PROGRAMS.ELD]: '#5c78ed',
  [PROGRAMS.MATH]: '#259774',
  [PROGRAMS.SCIENCE]: '#8A63C2',
  [PROGRAMS.BOOST]: '#36A3AA',
  [PROGRAMS.VOCAB_APP]: '#ef9781',
  [PROGRAMS.MATH_SUPPLEMENTAL]: '#c5e071',
  [PROGRAMS.MCLASS]: '#CF5EA2',
};

export const getProgramKey = (programName: string): PROGRAMS | undefined => {
  return Object.values(PROGRAMS).find((key) =>
    programName.toLowerCase().includes(key),
  );
};

export const getProgramColor = (
  programName: string,
  isProgramOutlined = false,
): string | null => {
  const programKey: string | undefined = getProgramKey(programName);

  if (!programKey) return null;

  if (isProgramOutlined) {
    return PROGRAMS_OUTLINED_COLORS[
      programKey as keyof typeof PROGRAMS_OUTLINED_COLORS
    ];
  }

  return PROGRAMS_COLORS[programKey as keyof typeof PROGRAMS_COLORS];
};

export const findProgramByAssetId = (programs: Program[], assetId: string) => {
  return programs.find((program) => {
    return program.contents.find((content) => {
      return content.assets.find((assetBk) => assetBk === assetId);
    });
  });
};

export const getProgramAssetsIds = (program: Program) => {
  return program.contents.reduce<string[]>((programAssets, content) => {
    const contentAssets = content.assets;

    const isEmptyContentAssets = contentAssets.every(
      (assetId) => assetId === null,
    );

    if (isEmptyContentAssets) return programAssets;

    return [...programAssets, ...contentAssets];
  }, []);
};
